export enum UserEmailUpdate {
    DESIGN_UPDATES = 'designUpdates',
    UNREAD_NOTIFICATIONS = 'unreadNotifications',
    WEEKLY_DIGEST = 'weeklyDigest',
    LOW_CREDIT_BALANCE = 'lowCreditBalance',
}

export const AllUserEmailUpdates = Object.values(UserEmailUpdate);

const UserEmailUpdateLabels: Record<UserEmailUpdate, string> = {
    [UserEmailUpdate.DESIGN_UPDATES]: 'Design Updates',
    [UserEmailUpdate.UNREAD_NOTIFICATIONS]: 'Unread Messages',
    [UserEmailUpdate.WEEKLY_DIGEST]: 'Weekly Digest',
    [UserEmailUpdate.LOW_CREDIT_BALANCE]: 'Low Credit Balance',
};

export const getUserEmailUpdateLabel = (update: UserEmailUpdate): string => UserEmailUpdateLabels[update];

export const isUserEmailUpdate = (value: string): value is UserEmailUpdate =>
    AllUserEmailUpdates.includes(value as UserEmailUpdate);
